import { IApiFavoritesResult } from 'affiny-core/modules/api/models/interactions/favorites/favorite.types';
import { paginatedRequest } from 'affiny-core/modules/helpers';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const FavoritesResource = {
  postFavorite: (
    myAboid: string,
    otherAboid: string,
    ratingStatus: string,
    ratingFeature: string,
    eventOrigin: string
  ) =>
    AffinyEndpoint.Rating.headers({
      'X-Event-Origin': eventOrigin,
    })
      .post({
        sender_member_id: Number(myAboid),
        receiver_member_id: Number(otherAboid),
        status: ratingStatus,
        feature: ratingFeature,
      })
      .res(),
  getReceivedFavorites: (
    accountId: string,
    pageNumber: number,
    pageSize: number
  ) =>
    paginatedRequest<IApiFavoritesResult>({
      apiEndPoint: AffinyEndpoint.Favorite.url(`/received/${accountId}/`),
      pageNumber,
      pageSize,
    }),
  getSentFavorites: (accountId: string, pageNumber: number, pageSize: number) =>
    paginatedRequest<IApiFavoritesResult>({
      apiEndPoint: AffinyEndpoint.Favorite.url(`/sent/${accountId}/`),
      pageNumber,
      pageSize,
    }),
};
